import { MeasurementSystem } from 'models';

import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/default-measurement-system';

const useMeasurementSystem = () => {
    const { measurementSystem } = useSnapshot(state);

    return measurementSystem || MeasurementSystem.IMPERIAL;
};

export { useMeasurementSystem };
